import { Point } from '@nivo/line'
import { useStyles } from './CustomTooltip.styles'
import { Divider, Link, Typography } from '@mui/material'
import { get } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { getTooltipDate } from './getTooltipDate'

export const CustomTooltip = ({
  point,
  color,
  timeZone,
}: {
  point: Point
  color: string
  timeZone?: string
}) => {
  const { classes } = useStyles()
  const formattedDate = getTooltipDate(
    get(point?.data, 'createdAt') ?? point?.data?.x,
    timeZone
  )
  const competitorName =
    get(point?.data, 'competitorName') || get(point?.data, 'name')

  const handleTooltipClick = () => window.open(get(point?.data, 'listingUrl'))

  return (
    <div className={classes.tooltip}>
      <div className={classes.tooltipHeader} data-testid={'tooltip-wrapper'}>
        <div className={classes.rank} style={{ background: color }}>
          {point?.data?.yFormatted}
        </div>
        <div className={classes.tooltipMeta}>
          {competitorName}
          {formattedDate && (
            <Typography className={classes.date}>{formattedDate}</Typography>
          )}
        </div>
      </div>

      {get(point?.data, 'productName') && (
        <>
          <Divider className={classes.divider} />
          <div className={classes.linkButton}>
            {get(point?.data, 'productName')}
            <Link
              onClick={handleTooltipClick}
              data-testid="add-a-contractDimensions-button"
            >
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                style={{
                  width: '14px',
                  height: '15px',
                  marginLeft: '10px',
                  color: '#ffcd04',
                }}
              />
            </Link>
          </div>
        </>
      )}
    </div>
  )
}
